import routerGuard from '@/helpers/routerGuard'

const routes = [{
        path: '/AddAssetCheckList/:id',
        name: 'AddAssetCheckList',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/AssetCheckList/AddAssetCheckList.vue'),
        meta: { moduleCode: 6004 }
    },
    {
        path: '/viewmonthlycontent',
        name: 'ViewMonthlyContent',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/MonthlyContent/monthlyContent.vue'),
        meta: { moduleCode: 1010 }
    },
    {
        path: '/monthlycontentdetail/:id',
        name: 'MonthlyContentDetail',
        //beforeEnter: guardMyroute,
        component: () =>
            import ('@/CompanyUserView/MonthlyContent/monthlyContentDetail.vue'),
        //beforeEnter: routerGuard.guardMyroute,
        meta: { moduleCode: 1010 }
    },
    {
        path: '/Course',
        name: 'CompanyManageCourse',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/Managecourse/manageCourse.vue'),
        meta: { moduleCode: 1009 }
    },
    {
        path: '/Course/CourseDetail/:id',
        name: 'CompanyManageCourseDetail',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/Managecourse/courseDetail.vue'),
        meta: { moduleCode: 1009 }
    },
    
    {
        path: '/manageambassadormonthlycontent',
        name: 'Manage Monthly Contents',
         
        component: () =>
            import ('@/CompanyUserView/MonthlyContent/manageMonthlyContent.vue'),
        meta: { moduleCode: 10140 }
    },
    {
        path: '/manageambassadormonthlycontent/create',
        name: 'AddMonthlyContent',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/MonthlyContent/addEditMonthlyContent.vue'),
        meta: { moduleCode: 10140 }
    },
    {
        path: '/manageambassadormonthlycontent/edit/:id',
        name: 'MonthlyContentEdit',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/MonthlyContent/addEditMonthlyContent.vue'),
        meta: { moduleCode: 10140 }
    },
    {
        path: '/favourites',
        name: 'Manage Favorites',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/ManageFavourite/favouriteList.vue'),
        meta: { moduleCode: 1005 }
    },
    {
        path: '/sendEmailToClient/:id',
        name: 'sendEmailToClient',
        component: () =>
            import ('@/CompanyUserView/ManageFavourite/sendEmailToClient.vue'),
        meta: { moduleCode: 1005 }
        //beforeEnter: guardMyroute,
    },
    {
        path: '/ownedProperties',
        name: 'ownedProperties',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/ManageOwnedProperties/ownedPropertiesList.vue'),
        meta: { moduleCode: 1004 }
        //beforeEnter: guardMyroute,
    },
    {
        path: '/receivedRequest/:id/:BookingId/:ShareId',
        name: 'receivedRequest',
        component: () =>
            import ('@/CompanyUserView/ManageOwnedProperties/receivedRequestList.vue'),
        meta: { moduleCode: 1004 }
        // beforeEnter: guardMyroute,
    },
    {
        path: '/userBookProperty/:id/:shareid',
        name: 'userBookProperty',
        component: () =>
            import ('@/CompanyUserView/ManageOwnedProperties/userBookedProperty.vue'),
        meta: { moduleCode: 1004 }
        //beforeEnter: guardMyroute,
    },

    {
        path: '/VactionSwapMarketplace',
        name: 'VactionSwapMarketplace',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/VacationSwap/VacationSwapMarketplace.vue'),
        meta: { moduleCode: 1012 }
    },
    {
        path: '/vactionSwapMarketplacedetail/:assetId/:shareid/:bookingId',
        name: 'VactionSwapMarketPlaceDetail',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/VacationSwap/vacationSwapMarketplaceDetails.vue'),
        meta: { moduleCode: 1012 }
    },
    {
        path: '/membershipdetail',
        name: 'memberShipDetail',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/MemberShip/memberShipDetail.vue'),
        meta: { moduleCode: 1011 }
    },

    {
        path: '/MeetingSchedule',
        name: 'manageMeetingSchedule',
        //beforeEnter: guardMyroute,
        component: () =>
            import ('@/CompanyUserView/ManageScheduleMeetings/manageMeetingSchedule.vue'),
        meta: { moduleCode: 9003 }
    },

    {
        path: '/assetreviewlist',
        name: 'assetreviewlist',
         beforeEnter: routerGuard.guardMyroute,     
        component: () =>
            import ('@/CompanyUserView/Assetreview/assetreviewlist.vue'),
        meta: { moduleCode: 9004 }

    },
    {
        path: '/myprofile',
        name: 'myprofile',
        component: () =>
            import ('@/CompanyUserView/MyProfile/myProfile.vue'),
        meta: { moduleCode: 1014 }
        // beforeEnter: routerGuard.guardMyroute,
    },
    {
        path: '/clientRegistration',
        name: 'clientRegistration',
        component: () =>
            import ('@/CompanyUserView/Registration/clientRegistration.vue'),
        /* meta: { moduleCode: }*/
        // beforeEnter: routerGuard.guardMyroute,
    },
    {
        path: '/AreaofInterestList',
        name: 'AreaofInterestList',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/AreaofInterest/AreaofInterestList.vue'),
        meta: { moduleCode: 1006 }
    },
    {
        path: '/addeditAreaofInterest',
        name: 'addeditAreaofInterest',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/AreaofInterest/addeditAreaofInterest.vue'),
        meta: { moduleCode: 1006 }
    },

    {
        path: '/EditbyId/:id',
        name: 'EditAreaofinterest',
        component: () =>
            import ('@/CompanyUserView/AreaofInterest/addeditAreaofInterest.vue'),
        meta: { moduleCode: 1006 }
        /* beforeEnter: guardMyroute,*/
    },
    {
        path: '/managearticles',
        name: 'manageArticles',
        beforeEnter: routerGuard.guardMyroute,

        component: () =>
            import ('@/CompanyUserView/ManageArticles/manageArticles.vue'),
        meta: { moduleCode: 1007 }
    },
    {
        path: '/articleDetail/:id',
        name: 'articleDetail',
        component: () =>
            import ('@/CompanyUserView/ManageArticles/articleDetail.vue'),
        /*meta: { moduleCode: }*/
        meta: { moduleCode: 1007 }
        /* beforeEnter: guardMyroute,*/
    },

    {
        path: '/editcontact/:id',
        name: 'editcontactById',
        component: () =>
            import ('@/CompanyUserView/ManageOwnedProperties/editcontact.vue'),
        meta: { moduleCode: 1004 }
        //beforeEnter: guardMyroute,
    },
    {
        path: '/ticket',
        name: 'Manage Tickets',
        beforeEnter: routerGuard.guardMyroute,

        component: () =>
            import ('@/CompanyUserView/ManageTicket/ticketList.vue'),
        meta: { moduleCode: 7011 }
    },
    {
        path: '/ticket/:id',
        name: 'Manage Ticket',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/ManageTicket/ticketList.vue'),
        meta: { moduleCode: 7011 }
    },
    {
        path: '/ticket/addTicket',
        name: 'Add Ticket',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/ManageTicket/addTicket.vue'),
        meta: { moduleCode: 7011 }
    },
    {
        path: '/viewTicket/:id',
        name: 'viewTicket',
        component: () =>
            import ('@/CompanyUserView/ManageTicket/ticketDetail.vue'),
        meta: { moduleCode: 7011 }
        /* beforeEnter: guardMyroute,*/
    },
    {
        path: '/editTicket/:id',
        name: 'EditTicket',
        component: () =>
            import ('@/CompanyUserView/ManageTicket/addTicket.vue'),
        meta: { moduleCode: 7011 }
        /* beforeEnter: guardMyroute,*/
    },
    {
        path: '/ticket/editticket/:id',
        name: 'Manage ticket | Edit ticket',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/ManageTicket/addTicket.vue'),
        meta: { moduleCode: 7011 }
    },

    {
        path: '/addeditcontact/:id',
        name: 'Manage Clients  | Add/Edit Client',
        component: () =>
            import ('@/CompanyUserView/ManageContacts/AddContact.vue'),
        meta: { moduleCode: 1008 }
        //beforeEnter: guardMyroute,
    },
    {
        path: '/ManageContacts',
        name: 'Manage Clients',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/ManageContacts/Contacts.vue'),
        meta: { moduleCode: 1008 }
        //beforeEnter: guardMyroute,
    },
    {
        path: '/shareLink',
        name: 'Amb shareLink',
        component: () =>
            import ('@/CompanyUserView/ManageContacts/shareLink.vue'),
        meta: { moduleCode: 1008 }
        //beforeEnter: guardMyroute,
    },
    {
        path: '/addcontact',
        name: 'Manage Clients | Add/Edit Client',
        component: () =>
            import ('@/CompanyUserView/ManageContacts/AddContact.vue'),
        meta: { moduleCode: 1008 }
        //beforeEnter: guardMyroute,
    },
    {
        path: '/editcontact/:id',
        name: 'editcontact',
        component: () =>
            import ('@/CompanyUserView/ManageContacts/AddContact.vue'),
        meta: { moduleCode: 1008 }
        //beforeEnter: guardMyroute,
    },
    {
        path: '/ManageDocument',
        name: 'ManageDocuments',
        component: () =>
            import ('@/CompanyUserView/ManageDocument/manageDocument.vue'),
        /*meta: { moduleCode: }*/
    },
    {
        path: '/ManageDocument/addeditDocument',
        name: 'AddEditdocument',
        component: () =>
            import ('@/CompanyUserView/ManageDocument/addeditDocument.vue'),
        /*meta: { moduleCode: }*/
        /* beforeEnter: guardMyroute,*/
    },
    {
        path: '/ManageDocument/addeditDocument/:id',
        name: 'Editdocument',
        component: () =>
            import ('@/CompanyUserView/ManageDocument/addeditDocument.vue'),
        /*meta: { moduleCode: }*/
        /* beforeEnter: guardMyroute,*/
    },
    {
        path: '/assignedTicket',
        name: 'Manage Assigned Tickets',
        component: () =>
            import ('@/CompanyUserView/ManageTicket/manageAssignedTicketList.vue'),
        meta: { moduleCode: 9011013 }
    },
    {
        path: '/assignedTicket/:id',
        name: 'Manage Assigned Ticket',
        component: () =>
            import ('@/CompanyUserView/ManageTicket/manageAssignedTicketList.vue'),
        meta: { moduleCode: 9011013 }
    },
    {
        path: '/ManageNotification',
        name: 'ManageNotification',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/dashboard/Notification.vue'),
        meta: { moduleCode: 7012 },
        /* beforeEnter: guardMyroute,*/
    },
    {
        path: '/assignedAgentTicket',
        name: 'Manage Assignet Tickets',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/CompanyUserView/ManageTicket/assignedTicketForAgentList.vue'),
        meta: { moduleCode: 10101010 }
    },
    {
        path: '/assignedAgentTicket/:id',
        name: 'Manage Assignet Ticket',
        component: () =>
            import ('@/CompanyUserView/ManageTicket/assignedTicketForAgentList.vue'),
        meta: { moduleCode: 10101010 }
    },
    {
        path: '/assetPublishedlist',
        name: 'assetPublishedlist',
        beforeEnter: routerGuard.guardMyroute,
        //beforeEnter: guardMyroute,
        component: () =>
            import ('@/CompanyUserView/AssetPublished/assetPublishedlist.vue'),
        meta: { moduleCode: 45784 }

    },
    {
        path: '/propertycontactinformation',
        name: 'contactinformation',
        component: () =>
            import ('@/CompanyUserView/managecontactinfo/contactinformation.vue'),
        meta: { moduleCode: 15258 }
    },
    {
        path: '/CommissionReport',
        name: 'Amb Commission Report',
        component: () =>
            import ('@/views/commissionReport/commissionReport.vue'),
        meta: { moduleCode: 101010 }
    },
    {
        path: '/rentPropertiesList',
        name: 'rentPropertiesList',
        component: () =>
            import ('@/CompanyUserView/ManageOwnedProperties/rentPropertiesList.vue'),
        meta: { moduleCode: 4017 }

    },
    {
        path: '/VactionSwapMarketplacerequestedStatus',
        name: 'VactionSwapMarketplacerequestedStatus',
        component: () =>
            import ('@/CompanyUserView/VacationSwap/VacationSwapMarketPlaceRequestStatus.vue'),
        meta: { moduleCode: 1012 }
    },
    {
        path: '/AssetMapping',
        name: 'AssetMapping',
        component: () =>
            import ('@/CompanyUserView/AssetMapping/AssetMapping.vue'),
        meta: { moduleCode: 1012 }
    },
    {
        path: '/MappedAsset',
        name: 'Mappped Asset',
        component: () =>
            import ('@/CompanyUserView/MappedAssetList/MappedAsset.vue'),
    },
    {
        path: '/AssetMapping/:state/:code/:error/:error_description',
        name: 'AssetMappings',
        component: () =>
            import ('@/CompanyUserView/AssetMapping/AssetMapping.vue'),
        meta: { moduleCode: 1012 }
    },
    {
        path: '/AddCancellationPolicy',
        name: 'Manage Cancellation Policies | Add/Edit Cancellation Policy',
        // beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/manageCancellationpolicy/AddCancellationPolicy.vue'),
        meta: { moduleCode: 6010 }
    },
    {
        path: '/EditCancellationPolicy/:id',
        name: 'Edit CancellationPolicy',
        // beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import ('@/views/managecompwebsites/manageCancellationpolicy/AddCancellationPolicy.vue'),
        meta: { moduleCode: 6010 }
    },
    {
        path: '/configureExternalSource',
        name: 'Configure External Source',
        component: () =>
            import ('@/CompanyUserView/AssetMapping/configureExternalSource.vue'),
    },
    {
        path: '/assetDocumentProcess',
        name: 'Asset Buy Process',
        //beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/CompanyUserView/AssetBuyDocumentProcess/assetBuyProcessList.vue'),
        meta: { moduleCode: 2006 }
    },
    {
        path: '/assetBuyDocument/:id',
        name: 'Asset Document Process',
        component: () =>
            import ('@/CompanyUserView/AssetBuyDocumentProcess/assetBuyDocumentProcess.vue'),
    },
    {
        path: '/assetBuyDocument',
        name: 'Asset Document Processes',
        component: () =>
            import ('@/CompanyUserView/AssetBuyDocumentProcess/assetBuyDocumentProcess.vue'),
    },
    {
        path: '/ManageCancellationPolicy',
        name: 'Manage Cancellation Policies',
        component: () =>
            import ('@/views/managecompwebsites/manageCancellationpolicy/ManageCancellationPolicyList.vue'),
        meta: { moduleCode: 6010 }
    },
    {
        path: '/ManageESignDocument',
        name: 'E-Sign Documents',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/CompanyUserView/ManageESignDocument/eSignDocumentList.vue'),
        meta: { moduleCode: 8016 }
    },
    {
        path: '/addeditform/:module/:subModule/:systemgenerated/:formMasterId',
        name: 'addeditform',
        component: () =>
            import ('@/views/crm/configurationsetting/manageform/addEditForm/addeditform.vue'),
    },
    {
        path: '/layoutformpreview',
        name: 'layoutformpreview',
        component: () =>
            import ('@/views/crm/shared/layoutformpreview/layoutformpreview.vue'),
    },
    {
        path: '/Surcharges',
        name: 'Surcharges',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/Surcharges/SurChargesListing.vue'),
        meta: { moduleCode: 7013 }
    },
    {
        path: '/CreateSurcharge',
        name: 'CreateSurcharge',
        component: () =>
            import('@/views/Surcharges/CreateSurcharge.vue'),
    },
    {
        path: '/Surcharges/EditSurcharges/:id',
        name: 'Surcharges | Add/Edit Surcharge',

        component: () =>
            import('@/views/Surcharges/CreateSurcharge.vue'),

    },
    {
        path: '/rentOutPropertyList',
        name: 'rentOutPropertiesList',
        component: () =>
            import('@/CompanyUserView/ManageOwnedProperties/rentOutPropertyList.vue')       

    },
    {
        path: '/BookingListing',
        name: 'BookingListing',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/OwnwrRezBookings/BookingListing.vue'),
        meta: { moduleCode: 7013 }

    },


    {
        path: '/CustomerBookingListing',
        name: 'CustomerBookingListing',
        beforeEnter: routerGuard.guardMyroute,

        component: () =>
            import('@/views/OwnwrRezBookings/CustomerBookingListing.vue'),
        meta: { moduleCode: 85256 }
    },


    {
        path: '/ManageCheckout',
        name: 'ManageCheckout',
        component: () =>
            import('@/views/OwnwrRezBookings/ManageCheckout.vue')
    },


    {
        path: '/CustomerBookingDetails/:id',
        name: 'CustomerBookingDetails',
        component: () =>
            import('@/views/OwnwrRezBookings/CustomerBookingDetails.vue')

    },


    {
        path: '/BookingListing/BookindDetail/:id',
        name: 'BookindDetails',
        beforeEnter: routerGuard.guardMyroute,

        component: () =>
            import('@/views/OwnwrRezBookings/BookindDetails.vue'),
        meta: { moduleCode: 7013 }

    },
    {
        path: '/BookingListing/CreateBooking',
        name: 'CreateBooking',
        beforeEnter: routerGuard.guardMyroute,

        component: () =>
            import('@/views/OwnwrRezBookings/CreateBooking.vue'),
            meta: { moduleCode: 7013 }

    },
    {
        path: '/ownrezsendemail/:id/:redirectFrom',
        name: 'Send Email',
        component: () =>
            import('@/views/Inquiry/ownerRezSendEmail.vue')
    },
    {
        path: '/ownrezemailhistory/:id/:redirectFrom',
        name: 'Email History',
        component: () =>
            import('@/views/Inquiry/ownerRezEmailHistory.vue')
    },
    {
        path: '/BookingDetail/EditBooking/:Id',
        name: 'EditBooking',
        component: () =>
            import('@/views/OwnwrRezBookings/CreateBooking.vue')

    },
    {
        path: '/SpecialBookingListing',
        name: 'SpecialBookingListing',
        component: () =>
            import('@/views/OwnwrRezBookings/SpecialRequestsLIsitng.vue')
    },
    {
        path: '/manageassets/AddHealthAndSafety/:id',
        name: 'AddHealthAndSafety',
        component: () =>
            import('@/views/OwnwrRezBookings/AddHealthAndSafety.vue')

    },
    {
        path: '/CustomerBookingListing/GuestInstructionsDetails/:AssetId',
        name: 'GuestInstructionsDetails',
        component: () =>
            import('@/views/OwnwrRezBookings/GuestInstructionsDetails.vue')

    },
     {
         path: '/HealthAndSafetyDetails/:id',
         name: 'HealthAndSafetyDetails',
        component: () =>
            import('@/views/OwnwrRezBookings/HealthAndSafetyDetails.vue')

    },
    {
        path: '/BookingListing/BookindDetailNew/:id',
        name: 'BookindDetailNew',
        component: () =>
            import('@/views/OwnwrRezBookings/BookingInformation.vue')

    },
    {
        path: '/Reports/EarningReports',
        name: 'EarningReports',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/reports/EarningReports.vue'),
        meta: { moduleCode: 45701 }

    },
    {
        path: '/Reports/NationalityReports',
        name: 'NationalityReports',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/reports/GuestsNationalityReports.vue'),
        meta: { moduleCode: 45704 }
    },
    {
        path: '/Reports/OccupancyReports',
        name: 'OccupancyReports',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/reports/OccupancyReports.vue'),
        meta: { moduleCode: 45705 }
    },
     {
        path: '/HouseKeeping',
         name: 'HouseKeeping',
         beforeEnter: routerGuard.guardMyroute,
        component: () =>
             import('@/views/HouseKeeping/HouseKeeping.vue'),
         meta: { moduleCode: 12702 }
    },
    {
        path: '/new-housekeeping',
        name: 'NewHouseKeeping',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/HouseKeeping/NewHouseKeepingDashboard.vue'),
        meta: { moduleCode: 12702 }
    },
    {
        path: '/Schedule',
        name: 'HouseKeepingSchedule',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/SetupSchedulingRule/Schedule.vue'),
        meta: { moduleCode: 12702 }
    },
    {
        path: '/ScheduleTaskList/:assetId',
        name: 'ScheduleTaskListByAsset',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/HouseKeeping/ScheduleTaskList.vue'),
        meta: { moduleCode: 12702 }
    },
    {
        path: '/ScheduleTaskList',
        name: 'ScheduleTaskList',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/HouseKeeping/ScheduleTaskList.vue'),
        meta: { moduleCode: 12702 }
    },
    {
        path: '/ScheduleTask',
        name: 'ScheduleTask',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/HouseKeeping/ScheduleTask.vue'),
        meta: { moduleCode: 12702 }
    },
    {
        path: '/ScheduleTask/:id',
        name: 'EditScheduleTask',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/HouseKeeping/ScheduleTask.vue'),
        meta: { moduleCode: 12702 }
    },
    {
        path: '/PropertyClosures',
        name: 'PropertyClosures',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/HouseKeeping/PropertyClosures.vue'),
        meta: { moduleCode: 12709 }
    },
    {
        path: '/ScheduleClosure',
        name: 'ScheduleClosure',
        component: () =>
            import('@/views/HouseKeeping/ScheduleClosure.vue')
    },
    {
        path: '/ScheduleClosure/:id',
        name: 'EditScheduleClosure',
        component: () =>
            import('@/views/HouseKeeping/ScheduleClosure.vue')
    },
    {
        path: '/ManageExperience',
        name: 'ManageExperience',
        component: () =>
            import('@/views/ManageExperience/ManageExperience.vue')
    },
     {
        path: '/ExperienceBooking',
         name: 'ExpBookinglistForGuests',
         beforeEnter: routerGuard.guardMyroute,
        component: () =>
             import('@/views/ManageExperience/ExpBookinglistForGuests.vue'),
         meta: { moduleCode: 13103 }
    },
    {
        path: '/ScheduleExperience',
        name: 'Schedule Experience',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/ManageExperience/ScheduleExperienceCalendar.vue'),
        meta: { moduleCode: 13104 }
    },
     {
        path: '/ManageExperience/:id',
         name: 'ManageExperiencebyid',

        component: () =>
            import('@/views/ManageExperience/ManageExperience.vue')
    },
    {
        path: '/experiencePackage/:id',
        name: 'Manage Experience Package',
        component: () =>
            import('@/views/ManageExperience/ManageExperiencePackage.vue')
    },
    {
        path: '/ExperienceBooking/ExperienceDetails/:id',
        name: 'ExperienceDetails',
        component: () =>
            import('@/views/ManageExperience/expBookingInformation.vue')
    },
    {
        path: '/BookingListing/CreateGolfCartBooking',
        name: 'Create GolfCart Booking',
        component: () =>
            import('@/views/OwnwrRezBookings/CreateGolfCartBooking.vue')

    },
    
    {
        path: '/DynamicStatusListing',
        name: 'DynamicStatus Listing',
        component: () =>
            import('@/views/ManageCartDynamicStatus/ManageCartDynamicStatusListing.vue')

    },
     {
         path: '/DynamicStatusListing/CreateCartDynamicStatus',
         name: 'CartDynamic Status',
        component: () =>
            import('@/views/ManageCartDynamicStatus/CreateCartDynamicStatus.vue')

    },
    {
        path: '/DynamicStatusListing/CreateCartDynamicStatus/:id',
        name: 'DynamicStatus | Add/Edit Status',

        component: () =>
            import('@/views/ManageCartDynamicStatus/CreateCartDynamicStatus.vue'),

    },
    {
        path: '/BookingListing/GolfCartBookindDetail/:id',
        name: 'GolfCartBookindDetail',
        component: () =>
            import('@/views/OwnwrRezBookings/GolfCartBookingDetails.vue')

    },
    {
        path: '/TapeChart',
        name: 'tap',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/OwnwrRezBookings/TapeChartGolf.vue'),
        meta: { moduleCode: 100451 }

    },
    {
        path: '/TapeChartnew',
        name: 'tapnew',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/OwnwrRezBookings/TapeChartNew.vue'),
        meta: { moduleCode: 100451 }

    },
    {
        path: '/Report/CommissionReport',
        name: 'Commission Report',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/reports/BookingCommissionReport.vue'),
        meta: { moduleCode: 100452 }
    },

    {
        path: '/TodayBooking',
        name: 'TodayBooking',
        component: () =>
            import('@/views/OwnwrRezBookings/TodayBooking.vue'),
        meta: { moduleCode: 7015 }

    },
  
    {      
        path: '/Report/CancelledBookingReport',
        name: 'CancelledBookingReport',
     
        component: () =>
            import('@/views/CancelBookingReport/cancelbookingreport.vue'),

    },
    {
        path: '/tapechart-new',
        name: 'tapechart-new',
        beforeEnter: routerGuard.guardMyroute,
        component: () =>
            import('@/views/OwnwrRezBookings/GolfCartBookingCalendar.vue'),
        meta: { moduleCode: 100451 }

    },

    {
        path: '/ManageCheckinReport',
        name: 'Manage Checkin Report',
        component: () =>
            import('@/views/OwnwrRezBookings/ManageCheckin_Report.vue'),

        meta: { moduleCode: 4649 }

    },
    {
        path: '/TodayCheckout',
        name: 'TodayCheckout',
        component: () =>
            import('@/views/OwnwrRezBookings/TodayCheckoutBooking.vue'),
        meta: { moduleCode: 4650 }


    },
    {
        path: '/CheckOutReport',
        name: 'CheckOutReport',
        component: () =>
            import('@/views/OwnwrRezBookings/ManageCheckOutReport.vue'),   
        meta: { moduleCode: 4651 }

    },
    {
        path: '/SalesReport',
        name: 'ManageSalesReport',
        component: () =>
            import('@/views/OwnwrRezBookings/ManageSalesReport.vue'),
        meta: { moduleCode: 4652 }

    },
    {
        path: '/MaintenanceDashboard',
        name: 'MaintenanceDashboard',
        component: () => import('@/views/Maintenance/MaintenanceDashboard.vue'),
        meta: { moduleCode: 12801 }
    },
    {
        path: '/MaintenanceChecklist/:assetId',
        name: 'MaintenanceChecklist',
        component: () => import('@/views/Maintenance/MaintenanceChecklist.vue'),
        meta: { moduleCode: 12801 }
    }

    
]
export default routes